import React from "react";
import useFormatById from "src/hooks/utils/useFormatById";

const LOAD_ERROR_NAME = "ScriptExternalLoadError";

export const PageStatus = ({ children }) => {
  return (
    <div className="m-a">
      <h5>{children}</h5>
    </div>
  )
};

export const PageStatusById = ({ id }) => {
  const formatMessage = useFormatById();
  return <PageStatus>{formatMessage(id)}</PageStatus>
};

export const LoadDefaultComponent = () => {
  const formatMessage = useFormatById();
  return <PageStatus>{formatMessage("LoadingComponent...")}</PageStatus>
};

const LoadErrorDefaultComponent = () => {
  const formatMessage = useFormatById();
  return <PageStatus>{formatMessage("FailedLoadComponent")}</PageStatus>
};

const CrashErrorDefaultComponent = () => {
  const formatMessage = useFormatById();
  return <PageStatus>{formatMessage("ComponentCrashed")}</PageStatus>
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, rerender: false };
  }

  static getDerivedStateFromError = error => ({ error });
  render = () => {
    if (this.state.error) {
      const LoadErrorComponent = this.props.LoadErrorComponent ?? LoadErrorDefaultComponent;
      const CrashErrorComponent = this.props.CrashErrorComponent ?? CrashErrorDefaultComponent;
      const ErrorComponent = this.state.error.name === LOAD_ERROR_NAME ? LoadErrorComponent : CrashErrorComponent;
      return <ErrorComponent />;
    }
    return this.props.children;
  };
}

export default ErrorBoundary;
